// ---------------------------------------------------------------------------
// InlineGateCard — wraps GateButtons in a small standalone card for gate
// items that don't have a richer functional card (e.g. "Code reviewed",
// "CHANGELOG updated", "Stakeholders notified").
// Split out of RunbookPhaseCards.jsx at iter86.83.
// ---------------------------------------------------------------------------
import { GateButtons } from "@/components/site-admin/GateButtons";

export function InlineGateCard({ title, description, children, ...gateProps }) {
    return (
        <div
            className="brutal-card-light p-2 space-y-1"
            data-testid={`inline-gate-card-${gateProps.itemId}`}
        >
            <div className="flex items-baseline gap-2 flex-wrap">
                <p className="text-[11px] font-bold text-white">{title}</p>
                {description && (
                    <p className="text-[10px] text-zinc-500 italic">{description}</p>
                )}
            </div>
            {children}
            <GateButtons {...gateProps} />
        </div>
    );
}
